import { useContext } from "react";

import type { TOrderDataContext } from "../types";
import OrderDataContext from "./OrderDataContext";

const useOrderData = (): TOrderDataContext => {
  const context = useContext(OrderDataContext);
  if (!context) {
    throw new Error("useOrderData must be used within a OrderDataContextProvider");
  }
  return context;
};

export default useOrderData;
